const GIFTING_FLOW_QUERY_PARAM = 'gifting-flow-enabled'

export default function useGiftFlowIsActive(queryString) {
  const urlParam = new URLSearchParams(queryString)
  const envGiftFlowFlag = process.env.GATSBY_GIFTING_FLOW_ACTIVE
  const queryGiftFlowFlag = urlParam.get(GIFTING_FLOW_QUERY_PARAM)

  return (
    envGiftFlowFlag === 'true' ||
    envGiftFlowFlag === '1' ||
    queryGiftFlowFlag === 'true' ||
    queryGiftFlowFlag === '1'
  )
}
